import {
  ArquivoFiltrosCriteria,
  ArquivoFiltrosOptions,
  ArquivoLogFiltrosCriteria,
  ArquivoLogFiltrosOptions,
} from "@workflow/types";
import { ArquivoDTO, ArquivoLogDTO } from "@/types/arquivo.type";
import { PageResponse } from "@/types/http.type";
import { buildQueryParams } from "@/utils/build-query-params";
import { httpClient } from "./httpClient";

/**
 * Auditoria admin de arquivos: listagem de todos os arquivos do sistema e
 * histórico de ações (downloads, etc.). Espelha o estilo do `PessoaService`
 * (listagem paginada server-side + opções de filtro).
 */
class ArquivoAuditoriaService {
  private readonly basePath = "api/v1/admin/arquivos";

  public async listArquivosPaginado(
    filter?: ArquivoFiltrosCriteria,
  ): Promise<PageResponse<ArquivoDTO>> {
    let url = `${this.basePath}/listagem`;
    if (filter) {
      const query = buildQueryParams(filter);
      if (query) url += "?" + query;
    }
    return httpClient.get<PageResponse<ArquivoDTO>>(url);
  }

  public async getArquivoFiltros(): Promise<ArquivoFiltrosOptions> {
    return httpClient.get<ArquivoFiltrosOptions>(`${this.basePath}/filtros`);
  }

  public async listLogsPaginado(
    filter?: ArquivoLogFiltrosCriteria,
  ): Promise<PageResponse<ArquivoLogDTO>> {
    let url = `${this.basePath}/logs/listagem`;
    if (filter) {
      const query = buildQueryParams(filter);
      if (query) url += "?" + query;
    }
    return httpClient.get<PageResponse<ArquivoLogDTO>>(url);
  }

  public async getLogFiltros(): Promise<ArquivoLogFiltrosOptions> {
    return httpClient.get<ArquivoLogFiltrosOptions>(`${this.basePath}/logs/filtros`);
  }
}

export const arquivoAuditoriaService = new ArquivoAuditoriaService();
